import React from 'react';
import PropTypes from 'prop-types';
import './custom-switch.scss';

function CustomSwitch({ size, color, className, label, ...otherProps }) {
  return (
    <label className={`custom-switch ${className} ${size} ${color}`}>
      {label !== '' && <span className="text">{label}</span>}
      <input type="checkbox" {...otherProps} />
      <span className="wrapper">
        <span className="switch-bg">
          <span className="ball" />
        </span>
      </span>
    </label>
  );
}

export default CustomSwitch;
CustomSwitch.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
};
CustomSwitch.defaultProps = {
  size: '',
  color: '',
  className: '',
  label: '',
};
